<section class="tips container-fluid">
    <div class="tips__content px-3 pb-4 pt-3">
        <div class="tips__content__top d-flex flex-row align-items-center mb-2">
            <img
                [src]="'images/Illutration-Circle-Travel.svg' | cdn"
                alt="tips"
                class="tips__content__top__svg"
            />
            <h2 class="tips__content__top__text mx-3 my-0">
                {{ 'fe_details_step5_tips_top' | translate }}
            </h2>
        </div>
        <div class="tips__content__bottom">
            <div class="tips__content__bottom__text">
                <ol class="tips__content__bottom__text__ol">
                    <li class="tips__content__bottom__text__ol__li">
                        {{
                            'fe_details_step5_tips_bottom_text_li_1' | translate
                        }}
                    </li>
                    <li class="tips__content__bottom__text__ol__li">
                        {{
                            'fe_details_step5_tips_bottom_text_li_2' | translate
                        }}
                    </li>
                    <li class="tips__content__bottom__text__ol__li">
                        {{
                            'fe_details_step5_tips_bottom_text_li_3' | translate
                        }}
                        <a
                            [routerLink]="
                                'questions/car-rental-conditions-and-policies'
                                    | formatUrl
                            "
                            target="_blank"
                            rel="noopener"
                            class="tips__content__bottom__text__ol__li__href"
                            >{{
                                'fe_details_step5_tips_bottom_text_li_3_1'
                                    | translate
                            }}</a
                        >
                    </li>
                </ol>
            </div>
        </div>
    </div>
</section>
